import React from 'react';
import { includes } from 'lodash';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import { getSubdomains } from '../../../api/Layers/layer-operations';
import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

const LayerSubdomainField = ({ layerSubType, layer }) => {
  if (
    includes(
      [LAYER_SUBTYPES.GEOJSONVT, LAYER_SUBTYPES.TILE_SERVER, LAYER_SUBTYPES.MAPBOX],
      layerSubType
    )
  ) {
    return (
      <Form.Group>
        <Form.Label>Subdomains</Form.Label>
        <Form.Control
          type="text"
          name="subdomains"
          defaultValue={getSubdomains(layer)}
          placeholder="Subdomains for the tile server"
        />
      </Form.Group>
    );
  }
  return '';
};
LayerSubdomainField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerSubdomainField;
